<template>
  <div>
    <!-- 筛选 -->
    <el-card>
      <el-row class="title_row">
        <el-col>
          <span class="title_class">选手信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="80px"
        ref="queryFormRef"
      >
        <el-row :gutter="50">
          <el-col :span="6">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择类型"
                style="width: 100%"
                v-model="queryForm.season"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select> </el-form-item
          ></el-col>
          <el-col :span="6">
            <el-form-item label="赛区" prop="districtId">
              <el-select
                placeholder="请选择类型"
                style="width: 100%"
                v-model="queryForm.districtId"
                @change="districtChange"
              >
                <el-option
                  v-for="item in dict_district"
                  :key="item.id"
                  :label="item.districtName"
                  :value="item.id"
                ></el-option>
              </el-select> </el-form-item
          ></el-col>
          <el-col :span="6">
            <el-form-item label="组别" prop="enrollmentLevel">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.enrollmentLevel"
                @change="levelChange"
              >
                <el-option v-for="item in dict_group"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"></el-option>
              </el-select> </el-form-item
          ></el-col>
          <el-col :span="6">
            <el-form-item label="姓名" prop="userName">
              <el-input
                v-model="queryForm.userName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="queryForm.phone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="18" align="right">
            <el-button
              type="primary"
              @click="getList"
              >查询</el-button
            >
            <el-button type="primary" plain @click="reset"
              >重置</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <!-- 比赛信息列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="12">
          <span class="title_class">选手信息列表({{ dataList.length }}人)</span>
        </el-col>
        <el-col :span="12" align="right">
              <el-button type="primary" icon="el-icon-download" plain @click="exportFn">批量导出</el-button>
            </el-col>
      </el-row>
      <!-- 英文国赛选手列表 -->
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <!-- <el-table-column label="赛季" prop="season"></el-table-column> -->
        <el-table-column label="赛区" prop="districtName"></el-table-column>
         <el-table-column label="姓名" prop="userName"></el-table-column>
         <el-table-column
          label="手机号"
          prop="phone"
        ></el-table-column>
        <!-- <el-table-column label="年级" prop="engGrade"></el-table-column> -->
        <el-table-column label="组别" prop="enrollmentLevel" :formatter="levelFormat"></el-table-column>
        <el-table-column
          label="学校"
          prop="schoolName"
          width="220px"
        ></el-table-column>
        <el-table-column label="微信小程序订单" prop="submitState">
          <template slot-scope="scope">
            <el-tag :type="scope.row.submitState ? 'success' : 'info'">
              {{ scope.row.submitState ? '已提交未支付' : '未提交' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100px">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="showBillInfo(scope.row)"
              >线下支付</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination> -->
    </el-card>
    <!-- 修改用户信息 -->
    <el-dialog
      title="确认订单信息"
      :visible.sync="billVisible"
      @close="billInfoClose"
      width="700px"
    >
      <!-- 个人信息 -->
      <div>
        <el-descriptions title="用户信息">
          <template slot="title">
            <div class="gift-title">用户信息</div>
          </template>
          <el-descriptions-item label="姓名">{{ billInfoForm.userName }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ billInfoForm.phone }}</el-descriptions-item>
          <el-descriptions-item label="组别">{{ levelFormat(billInfoForm) }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <!-- 付费 -->
      <div style="margin-bottom: 20px;">
        <div class="gift-title">付费产品</div>
        <div v-for="(item,index) of paidProducts" :key="index">
          <div class="order-info" v-if="!item.isFree">
            <div>
              <!-- 为52、53、54、55、56添加勾选框 -->
              <el-checkbox
                v-if="['52', '53', '54', '55', '56'].includes(item.id)"
                v-model="item.checked"
                @change="handleCheckboxChange(item, index)"
                style="margin-right: 10px;"
              ></el-checkbox>
              <div class="order-left">{{ item.tproductName }}</div>
            </div>
            <div class="order-price" v-if="item.id === '51'">¥ {{ item.price }}</div>
            <div class="order-price" v-if="['52', '53'].includes(item.id)">¥ {{ item.price }}</div>
            <div class="order-price" v-if="item.id === '54'">× {{ item.num }}</div>
            <div class="order-price" v-if="['55', '56'].includes(item.id)">¥ {{ item.price }} × {{ item.num }}</div>
            <!-- 为54、55、56添加计数器 -->
            <div v-if="['54', '55', '56'].includes(item.id)" class="quantity-counter">
              <el-button
                size="mini"
                @click="decreaseQuantity(index)"
                :disabled="item.num <= 0"
              >-</el-button>
              <span style="margin: 0 10px;">{{ item.num }}</span>
              <el-button
                size="mini"
                @click="increaseQuantity(index)"
              >+</el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 免费 -->
      <el-collapse v-model="giftCollapseActive" accordion>
        <el-collapse-item name="gifts">
          <template slot="title">
            <span class="gift-title">赠送产品</span>
          </template>
          <div v-for="(item,index) of paidProducts" :key="index">
            <div class="order-info" v-if="item.isFree">
              <div class="order-left">{{ item.tproductName }}</div>
              <div class="success-font">免费</div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div>
        <div class="gift-title mtb">支付凭证</div>
        <el-upload
          class="wordImg"
          :action="this.$http.defaults.baseURL + 'upload/uploadFileAliOss'"
          :headers="headerObj"
          :show-file-list="false"
          :on-success="handleUploadSimpleImgSuccess"
          :before-upload="beforeImgUpload"
          :data="{
              filePath: 'chineseWord/erp/finalOrder',
          }"
        >
          <img
            v-if="nationPayFile"
            :src="nationPayFile"
            class="wordImg"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="total-amount-container">
        <div class="total-amount-content">
          <i class="el-icon-money" style="color: #4096ff; margin-right: 8px;"></i>
          <span class="total-amount-text">费用合计：</span>
          <!-- <span v-if="!isEdit" class="total-amount-value">¥ {{ orderTotalPrice }}</span> -->
          <!-- <span v-else> -->
          <span>
            ¥ <el-input style="width: 100px;" v-model="orderTotalPrice"></el-input>
          </span>
          <!-- </span> -->
        </div>
        <!-- <el-button type="primary" plain size="small" @click="showEditTotalAmount" class="edit-total-btn">修改</el-button> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="billVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="billInfoClicked"
          >确认线下支付</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import $common from '@/methods/common.js'
import { queryDistrictPage } from '@/http/api'
export default {
  props: {
    level: {
      type: String
    },
    districtId: {
      type: String
    }
  },
  data () {
    return {
      productId: '12',
      billInfoForm: {
      },
      billVisible: false,
      queryForm: {
        season: this.$chnEngStatusCode.defaultSeason,
        districtId: '',
        enrollmentLevel: '',
        phone: '',
        userName: ''
      },
      // billInfoFormRules: {
      //   phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }]
      // },
      // areasData: areaJson.areas,
      dataList: [],
      dict_district: [],
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }),
      dict_grade: this.$userInfo.getGradeData(),
      dict_gender: this.$userInfo.getDataList(this, 'e_sex').then(value => { this.dict_gender = value }),
      dict_group: this.$userInfo.dict_group(),
      paidProducts: [],
      giftCollapseActive: '',
      orderTotalPrice: '',
      headerObj: {
        Authorization: localStorage.getItem('Authorization')
      },
      nationPayFile: '',
      isEdit: false
    }
  },
  created () {
  },
  computed: {
    $common () { return $common } // 公共方法
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    // 获取赛区筛选数据
    getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
        this.searchFn()
      }).catch((err) => {
        console.log('err', err)
      })
    },
    districtChange () {
      this.$emit('updateDistrict', this.queryForm.districtId)
    },
    levelChange () {
      this.$emit('updateLevel', this.queryForm.enrollmentLevel)
    },
    searchFn () {
      this.queryForm.enrollmentLevel = this.level
      this.queryForm.districtId = this.districtId
      this.getList()
    },
    exportFn () {
      this.$http.get('examinationUser/exportPromoteNoPayUser', { params: this.queryForm }).then(res => {
        if (res.code === 200) {
          window.open(res.data)
        }
      })
    },
    // 获取英文国赛选手信息信息
    async getList () {
      // queryNationEngPage(this.queryForm).then((res) => {
      this.$http.get('examinationUser/selectPromoteNoPayUser', { params: this.queryForm }).then(res => {
        this.dataList = res.data
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 用户点击跳转用户详情
    handleToUserDetails (userId) {
      this.$router.push({
        path: '/c_data_Management/c_player_registInfo_details',
        query: { userId }
      })
    },
    // 修改用户信息
    showBillInfo (rowData) {
      if (rowData.submitState) {
        this.$confirm('该选手已在微信小程序中提交订单，请在“总决选选手信息”列表中查询此选手，进行线下支付操作。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.changeUoloadData()
        }).catch(() => { })
      } else {
        this.nationPayFile = ''
        this.userId = rowData.userId
        this.$http.get('lexicon/getTbProductDetailList?productId=' + this.productId).then(res => {
          if (res.code === 200) {
            this.billInfoForm = rowData
            this.billVisible = true
            this.paidProducts = res.data
            this.paidProducts.find(item => item.id === '51').num = 1
            this.paidProducts.forEach(item => {
              item.checked = item.id === '51'
            })
            this.calculateTotalPrice()
          }
        })
      }
    },
    billInfoClose () {
      // this.$refs.billInfoFormRef.resetFields()
      this.billVisible = false
    },
    levelFormat (data) {
      return data.enrollmentLevel ? this.dict_group.find(item => item.dictValue === data.enrollmentLevel).dictLabel : '--'
    },
    reset () {
      this.queryForm.phone = ''
      // this.queryForm.engName = ''
      // this.queryForm.schoolName = ''
      this.$refs.queryFormRef.resetFields()
      this.getList()
    },
    // handleSizeChange (newSize) {
    //   this.queryForm.pageSize = newSize
    //   this.getList()
    // },
    // handleCurrentChange (newCurPage) {
    //   this.queryForm.pageNum = newCurPage
    //   this.getList()
    // },
    // 修改点击事件
    billInfoClicked () {
      // this.$confirm('请再次确认是否修改?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(async () => {
      //   this.changeUoloadData()
      // }).catch(() => { })
      if (!this.nationPayFile) {
        return this.$message.warning('请上传缴费凭证')
      }
      const form = {
        activityType: this.$chnEngStatusCode.activityType,
        nationPayFile: this.nationPayFile,
        paymentAmount: this.orderTotalPrice,
        productDetailId: this.paidProducts,
        productId: this.productId,
        raceSchedule: 4,
        season: this.$chnEngStatusCode.defaultSeason,
        userId: this.userId
      }
      this.$http.post('examinationUser/confirmPayV2', form).then(res => {
        if (res.code === 200) {
          this.$message.success('确认线下支付成功')
          this.billVisible = false
          this.getList()
        }
      })
    },
    calculateTotalPrice () {
      this.orderTotalPrice = 0
      this.paidProducts.forEach(item => {
        // 计算勾选的产品价格,加上国赛参赛选手(51)的价格
        if (item.checked === true || item.id === '51') {
          this.orderTotalPrice += Number(item.price) * item.num
        }
      })
      this.orderTotalPrice = this.orderTotalPrice.toFixed(2)
    },
    // 处理勾选框变化
    handleCheckboxChange (item, index) {
      console.log('勾选框变化:', item, index)

      // 根据产品ID设置数量
      if (['52', '53'].includes(item.id)) {
        // 52和53默认数量为1
        item.num = item.checked ? 1 : 0
      } else if (['54', '55', '56'].includes(item.id)) {
        // 54、55、56根据计数器数量，如果取消勾选则数量为0
        if (!item.checked) {
          item.num = 0
        } else if (item.num === 0) {
          // 如果勾选但数量为0，则设置为1
          item.num = 1
        }
      }

      // 重新计算总价
      this.calculateTotalPrice()
    },
    // 增加数量
    increaseQuantity (index) {
      this.paidProducts[index].num++
      // 如果数量从0增加到1，则自动选中
      if (this.paidProducts[index].num === 1) {
        this.paidProducts[index].checked = true
      }
      // 重新计算总价
      this.calculateTotalPrice()
    },
    // 减少数量
    decreaseQuantity (index) {
      if (this.paidProducts[index].num > 0) {
        this.paidProducts[index].num--
        // 如果数量减到0，则取消选中状态
        if (this.paidProducts[index].num === 0) {
          this.paidProducts[index].checked = false
        }
        // 重新计算总价
        this.calculateTotalPrice()
      }
    },
    showEditTotalAmount () {
      this.isEdit = true
    },
    handleUploadSimpleImgSuccess (res, file) {
      this.nationPayFile = res.data
    },
    beforeImgUpload (file) {
      const isJPGPNG = (file.type === 'image/jpeg' || file.type === 'image/png')
      const isLt2M = file.size / 1024 / 200

      if (!isJPGPNG) {
        this.$message.error('请上传图片格式')
      }
      // if (!isLt2M) {
      //   this.$message.error('上传图片大小不能超过 200KB!')
      // }
      return isJPGPNG && isLt2M
    }
  }
}
</script>
<style lang="less" scoped>
.input {
  margin-top: 20px;
  width: 100%;
  box-sizing: border-box;
}
.exam_span_class {
  font-size: 14px;
  font-weight: 600;
  line-height: 30px;
  font-weight: 500;
  color: #616161;
}
.topmenu-backview {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 60px;
  justify-content: flex-start;
}
.paycost_span_class {
  font-size: 14px;
  font-weight: 600;
  line-height: 40px;
  height: 40px;
  padding: 0px 10px;
  font-weight: 500;
  color: #616161;
}
.change_paycost_btn {
  width: 140px;
  height: 40px;
  margin-left: 20px;
}
.table_span_class {
  font-size: 8px;
  color: #616161;
}
.Title {
  font-size: 16px !important;
  color: black !important;
}
.redcolor {
  color: red;
}
.lightgreen-box {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.payment-Voucher-class {
  width: 80px;
  height: 80px;
}
.bottom-paycost-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.paycost-info-title {
  width: 100%;
  text-align: right;
  font-size: 16px;
  line-height: 30px;
  font-weight: 900;
}
.paycost-info-img {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.paycostinfo-lefttitle {
  font-size: 16px;
  margin-top: 10px;
  line-height: 30px;
  font-weight: 900;
}
.elformitemclass {
  margin-bottom: 0px !important;
}
.paycost-parents {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.userlist-back {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 30px;
}
.userSelectimg {
  width: 20px;
  height: 20px;
}
.userlist-backview {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
}
.userSelectimg {
  width: 20px;
  height: 20px;
}

.userSelectStr {
  width: 350px;
  font-size: 16px;
  color: black;
  text-align: left;
  margin-left: 10px;
}
.userSelectStrchild {
  width: 210px;
  font-size: 16px;
  color: black;
  text-align: left;
}
.userSelectStrchildView {
  width: 240px;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
}
.marageTop {
  margin-top: 20px;
}
.childStr-class {
  font-size: 12px;
}
.numberInputclasschild {
  width: 130px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.upOrDownClass {
  width: 20px;
  height: 20px;
}
.fellowNumberClass {
  font-size: 16px;
  color: black;
  text-align: center;
  padding: 0px 20px;
}
.userInfoStr {
  font-size: 16px;
  text-align: left;
  color: black;
  /* height: 60rpx;
      line-height: 60rpx; */
}
.roomNumberStr {
  font-size: 16px;
  text-align: left;
  color: black;
  text-align: right;
  font-weight: 700;
}
.homeNumberView {
  width: 80%;
  height: 25px;
  line-height: 25px;
  text-align: center;
  font-size: 16px;
  color: black;
  background-color: #fec200;
  border-radius: 12.5px;
}
.lineView {
  width: 100%;
  height: 1px;
  background-color: black;
  margin: 20px 0px;
}

.marginBottom {
  margin-bottom: 20px;
}
.couponsTitleStr {
  font-size: 16px;
  color: black;
  text-align: left;
  font-weight: 900;
}

.couponsPriceStr {
  font-size: 16px;
  font-weight: 700;
  color: black;
  text-align: right;
}
.changePriceStr {
  font-size: 12px;
  color: rgb(42, 81, 255);
  text-align: right;
  text-decoration: underline;
}
.footer-view {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.SelectPriceStr {
  font-size: 16px;
  font-weight: 700;
  color: black;
  text-align: center;
  position: absolute;
  right: 70px;
}
.redcolor {
  color: red;
  font-size: 20px;
}
/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
/deep/ input[type="number"] {
  -moz-appearance: textfield !important;
}
.div_algin_right {
  text-align: right;
}

.order-info{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 22px;
  font-size: 14px;
  height: 42px;
  border-bottom: 1px dashed #dadada;
  .order-left{
    display: inline-block;
    width: 140px;
  }
  .order-price{
    width: 100px;
    text-align: right;
  }
}
.total-amount-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  // border-radius: 8px;
  // border: 1px solid #dee2e6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.total-amount-content {
  display: flex;
  align-items: center;
  font-size: 18px;
}

.total-amount-text {
  color: #495057;
  font-weight: 500;
  margin-right: 8px;
}

.total-amount-value {
  color: #409eff;
  font-weight: bold;
  font-size: 20px;
}
.gift-title{
  color: #409eff;
  font-weight: bold;
  font-size: 14px;
}
.mtb{
  margin: 14px 0;
}
.success-font{
  color: #67c23a;
}
.wordImg {
  width: 100px;
  height: 100px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #a8b1bd;
  border-radius: 4px;
}
</style>
